<ng-container *ngIf="subtraction && !disabled">
  <button *ngIf="quantity > 0" mat-icon-button class="box-quantity-button box-quantity-remove" (click)="onRemove()">
    -
  </button>
</ng-container>
<span *ngIf="quantity > 0" class="box-quantity-number ods-typography-subtitle-s">
  {{ quantity }}
</span>
<button *ngIf="!disabled" mat-icon-button class="box-quantity-button box-quantity-add" (click)="onAdd()">+</button>
